import { render, staticRenderFns } from "./create-workflow-drawer.vue?vue&type=template&id=5fac4bfc&"
import script from "./create-workflow-drawer.vue?vue&type=script&lang=ts&"
export * from "./create-workflow-drawer.vue?vue&type=script&lang=ts&"
import style0 from "./create-workflow-drawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports